export const NAV_LINKS = [
  { key: 'top', label: '首页' },
  { key: 'feed', label: '热点速递' },
  { key: 'channels', label: '频道快讯' },
  { key: 'rank', label: '今日热榜' },
  { key: 'reports', label: '深度特辑' },
  { key: 'faq', label: '常见问题' },
  { key: 'about', label: '关于我们' },
];

export const CATEGORIES = ['全部', '娱乐', '科技', '社会', '网络', '生活', '体育', '财经'];

export const TICKER_ITEMS = [
  '今日新增话题 128 条，实时热度榜持续刷新',
  '暑期档多部新片口碑陆续解禁，观众讨论升温',
  '折叠屏新品集中发布，轻薄形态成关注焦点',
  '演唱会市场持续火爆，多城加场消息刷屏',
  '城市夜经济热度走高，青年消费场景更丰富',
  '端侧大模型应用加速落地，随身助手成新热点',
  '微短剧内容出海升温，三分钟叙事受关注',
  '文旅小城目的地被重新发现，短途游预订增长',
];

export const FEATURED = {
  cat: '综合 · 今日头条',
  tag: '抢先看',
  title: '暑期档与演唱会双线升温：这一届网友的钱包和注意力都去哪儿了',
  summary: '从电影银幕到万人场馆，从短视频碎片到数字主播，观众的注意力正被重新瓜分。51黑瓜速递带你梳理本轮娱乐消费热潮背后的内容逻辑与消费趋势。',
  time: '今天 09:26',
  views: '128.6万',
  read: 128600,
  image: 'https://readdy.ai/api/search-image?query=editorial%20newsroom%20illustration%20showing%20a%20crowded%20pop%20concert%20stage%20seen%20from%20above%2C%20warm%20amber%20spotlights%20and%20vermillion%20red%20glow%2C%20flat%20modern%20vector%20style%20with%20subtle%20paper%20grain%2C%20soft%20cream%20background%2C%20cohesive%20warm%20palette%2C%20minimal%20clean%20composition%2C%20editorial%20illustration%20aesthetic&width=1200&height=760&seq=heigua-hero-01&orientation=landscape',
};

export const FEED_ITEMS = [
  {
    id: 'f01', cat: '娱乐', tag: '爆', title: '暑期档新片口碑分化背后，观众到底在为什么买单',
    summary: '类型化叙事与情绪价值成为关键词，口碑与票房的错位让影院排片更趋谨慎。',
    time: '今天 11:02', views: '86.3万', read: 863000,
    image: 'https://readdy.ai/api/search-image?query=flat%20editorial%20vector%20illustration%20of%20film%20theater%20audience%20watching%20a%20glowing%20screen%20at%20dusk%2C%20warm%20cream%20and%20light%20beige%20backdrop%2C%20red%20and%20amber%20accent%20lights%2C%20clean%20minimal%20modern%20style%2C%20soft%20paper%20texture%2C%20cinematic%20warm%20tone%2C%20cohesive%20editorial%20illustration&width=640&height=480&seq=heigua-fc-01&orientation=squarish',
  },
  {
    id: 'f02', cat: '科技', tag: '新', title: '折叠屏加速迭代：轻薄与耐用，能不能一次给全',
    summary: '铰链工艺与屏幕材料持续升级，轻薄机身成为厂商新一轮角力的主战场。',
    time: '今天 10:44', views: '41.9万', read: 419000,
    image: 'https://readdy.ai/api/search-image?query=minimalist%20editorial%20vector%20illustration%20of%20a%20sleek%20foldable%20smartphone%20half%20opened%20on%20a%20plain%20cream%20surface%2C%20warm%20beige%20background%2C%20soft%20amber%20lighting%2C%20geometric%20flat%20shapes%2C%20subtle%20paper%20grain%2C%20modern%20tech%20product%20rendering%20style%2C%20cohesive%20warm%20editorial%20tone&width=640&height=480&seq=heigua-fc-02&orientation=squarish',
  },
  {
    id: 'f03', cat: '社会', tag: '热', title: '城市夜经济升温，年轻人的"晚高峰"才开始',
    summary: '深夜食堂、夜间文博与夜市演艺叠加，消费时间线正从日间向夜间延伸。',
    time: '今天 09:58', views: '63.2万', read: 632000,
    image: 'https://readdy.ai/api/search-image?query=flat%20vector%20editorial%20illustration%20of%20a%20lively%20night%20street%20market%20with%20glowing%20warm%20lanterns%2C%20cream%20and%20dusk%20beige%20palette%2C%20vermillion%20red%20banners%20and%20amber%20glow%2C%20modern%20minimal%20style%2C%20clean%20composition%2C%20subtle%20paper%20texture%2C%20cohesive%20warm%20editorial%20illustration%20aesthetic&width=640&height=480&seq=heigua-fc-03&orientation=squarish',
  },
  {
    id: 'f04', cat: '网络', tag: '热', title: '短视频信息流里，我们是不是正在失去耐心',
    summary: '三秒定胜负的内容生产逻辑，让深度叙事与即时满足之间拉扯得更明显。',
    time: '今天 09:12', views: '72.4万', read: 724000,
    image: 'https://readdy.ai/api/search-image?query=abstract%20flat%20vector%20illustration%20of%20overlapping%20phone%20screens%20with%20play%20buttons%20and%20speech%20bubbles%20in%20a%20feed%20layout%2C%20warm%20cream%20background%2C%20vermillion%20red%20and%20amber%20accent%20shapes%2C%20minimal%20modern%20style%2C%20subtle%20paper%20grain%2C%20cohesive%20editorial%20digital%20illustration&width=640&height=480&seq=heigua-fc-04&orientation=squarish',
  },
  {
    id: 'f05', cat: '生活', tag: '新', title: '轻食与咖啡之外，都市人的"第三空间"正在被重新定义',
    summary: '书店、健身馆与社区会客厅都试图承接人们下班后的那一段留白时间。',
    time: '今天 08:47', views: '38.5万', read: 385000,
    image: 'https://readdy.ai/api/search-image?query=cozy%20flat%20editorial%20vector%20illustration%20of%20a%20sunlit%20community%20coffee%20house%20with%20bookshelves%20and%20green%20plants%2C%20warm%20cream%20and%20beige%20palette%2C%20soft%20amber%20sunlight%20through%20window%2C%20minimal%20modern%20style%2C%20clean%20composition%2C%20subtle%20paper%20texture%2C%20cohesive%20warm%20lifestyle%20illustration&width=640&height=480&seq=heigua-fc-05&orientation=squarish',
  },
  {
    id: 'f06', cat: '财经', tag: '热', title: '文旅消费复苏进行时，小城目的地被重新发现',
    summary: '个性化与松弛感成为旅行新标尺，小众县城正在承接被重估的出行需求。',
    time: '今天 08:21', views: '52.1万', read: 521000,
    image: 'https://readdy.ai/api/search-image?query=flat%20editorial%20vector%20illustration%20of%20a%20quaint%20small%20town%20with%20old%20rooftops%20and%20a%20winding%20river%20at%20golden%20hour%2C%20warm%20cream%20sky%2C%20terracotta%20and%20amber%20tone%20buildings%2C%20minimal%20modern%20style%2C%20subtle%20paper%20texture%2C%20cohesive%20warm%20travel%20editorial%20illustration%20aesthetic&width=640&height=480&seq=heigua-fc-06&orientation=squarish',
  },
  {
    id: 'f07', cat: '娱乐', tag: '独', title: '演唱会市场井喷之后：一票难求与理性回归并存',
    summary: '场次与上座双双走高，黄牛治理与消费体验成为行业绕不开的议题。',
    time: '今天 07:53', views: '47.8万', read: 478000,
    image: 'https://readdy.ai/api/search-image?query=editorial%20flat%20vector%20illustration%20of%20a%20massive%20concert%20crowd%20with%20raised%20hands%20and%20colorful%20stage%20lights%2C%20warm%20cream%20to%20deep%20amber%20gradient%20background%2C%20vermillion%20red%20accents%2C%20minimal%20modern%20style%2C%20subtle%20paper%20grain%2C%20cohesive%20warm%20music%20editorial%20illustration&width=640&height=480&seq=heigua-fc-07&orientation=squarish',
  },
  {
    id: 'f08', cat: '科技', tag: '爆', title: '端侧大模型落地加速：手机上的"随身助手"到底怎么选',
    summary: '隐私、算力与场景成为关键变量，本地化智能体验正在走进日常生活。',
    time: '今天 07:20', views: '69.7万', read: 697000,
    image: 'https://readdy.ai/api/search-image?query=flat%20editorial%20vector%20illustration%20of%20a%20smartphone%20glowing%20with%20abstract%20neural%20network%20nodes%20floating%20above%2C%20warm%20cream%20background%2C%20vermillion%20red%20and%20amber%20node%20glows%2C%20minimal%20modern%20tech%20style%2C%20subtle%20paper%20texture%2C%20cohesive%20warm%20editorial%20illustration%20aesthetic&width=640&height=480&seq=heigua-fc-08&orientation=squarish',
  },
  {
    id: 'f09', cat: '社会', tag: '独', title: '青年就业观察：副业与多元成长，正在成为新的关键词',
    summary: '从兴趣变现到技能组合，年轻人在主业之外尝试重新定义自己的价值路径。',
    time: '今天 06:45', views: '58.3万', read: 583000,
    image: 'https://readdy.ai/api/search-image?query=flat%20editorial%20vector%20illustration%20of%20a%20young%20person%20working%20on%20a%20laptop%20at%20a%20desk%20with%20sketchbook%20and%20coffee%20cup%2C%20warm%20cream%20background%2C%20soft%20amber%20lighting%2C%20minimal%20modern%20style%2C%20subtle%20paper%20grain%2C%20cohesive%20warm%20career%20editorial%20illustration%20aesthetic&width=640&height=480&seq=heigua-fc-09&orientation=squarish',
  },
  {
    id: 'f10', cat: '网络', tag: '新', title: '数字主播当道，虚拟形象如何塑造"真实感"',
    summary: '从外形到人格设定，技术与内容团队正在联手补齐屏幕对面的温度。',
    time: '今天 06:12', views: '35.4万', read: 354000,
    image: 'https://readdy.ai/api/search-image?query=flat%20editorial%20vector%20illustration%20of%20a%20stylized%20friendly%20digital%20avatar%20hosting%20inside%20a%20rounded%20screen%20frame%2C%20warm%20cream%20background%2C%20vermillion%20red%20and%20amber%20accents%2C%20minimal%20modern%20style%2C%20subtle%20paper%20texture%2C%20cohesive%20warm%20digital%20editorial%20illustration%20aesthetic&width=640&height=480&seq=heigua-fc-10&orientation=squarish',
  },
  {
    id: 'f11', cat: '体育', tag: '热', title: '全民健身走进社区：球类场馆预约为何越来越火',
    summary: '从专业场馆到街角球场，预约式健身正把运动变成一种日常社交。',
    time: '今天 05:50', views: '33.9万', read: 339000,
    image: 'https://readdy.ai/api/search-image?query=flat%20editorial%20vector%20illustration%20of%20people%20playing%20basketball%20on%20a%20sunny%20neighborhood%20court%2C%20warm%20cream%20and%20amber%20afternoon%20light%2C%20vermillion%20red%20jersey%20accents%2C%20minimal%20modern%20style%2C%20subtle%20paper%20texture%2C%20cohesive%20warm%20sports%20editorial%20illustration%20aesthetic&width=640&height=480&seq=heigua-fc-11&orientation=squarish',
  },
  {
    id: 'f12', cat: '生活', tag: '热', title: '户外运动从小众到日常，城市露营的新玩法火了',
    summary: '轻量化装备与近郊营地让"说走就走"成为可能，社交属性被进一步放大。',
    time: '今天 05:16', views: '46.2万', read: 462000,
    image: 'https://readdy.ai/api/search-image?query=flat%20editorial%20vector%20illustration%20of%20a%20cozy%20campsite%20at%20dusk%20with%20a%20tent%20campfire%20and%20string%20lights%2C%20warm%20cream%20to%20amber%20sky%20gradient%2C%20vermillion%20red%20blanket%20accent%2C%20minimal%20modern%20style%2C%20subtle%20paper%20texture%2C%20cohesive%20warm%20outdoor%20editorial%20illustration%20aesthetic&width=640&height=480&seq=heigua-fc-12&orientation=squarish',
  },
];

export const CHANNEL_NEWS: Record<string, { time: string; dot: string }[]> = {
  '娱乐': [
    { time: '10:40', dot: '暑期档新片口碑陆续解禁，类型片成票房主力' },
    { time: '10:12', dot: '多场演唱会宣布加场，票务平台开启新一轮预约' },
    { time: '09:31', dot: '微短剧内容出海升温，三分钟叙事走向海外市场' },
    { time: '08:55', dot: '年度音乐奖项公布入围名单，讨论持续发酵' },
    { time: '08:02', dot: '老牌IP宣布重启，情怀营销能否再创佳绩引热议' },
    { time: '07:20', dot: '院线端午档片单曝光，多部影片同台竞技' },
  ],
  '科技': [
    { time: '10:28', dot: '折叠屏新品集中发布，铰链工艺成为比拼重点' },
    { time: '09:47', dot: '端侧大模型应用上新，离线智能助手更受关注' },
    { time: '08:59', dot: '新一代智能穿戴发布，续航与健康监测成卖点' },
    { time: '08:06', dot: '国产存储芯片产能爬坡，供应链格局生变' },
    { time: '07:14', dot: '开源大模型更新迭代，开发者社区热度走高' },
  ],
  '社会': [
    { time: '10:22', dot: '多地推出夜间公交与延时服务，便利夜经济' },
    { time: '09:38', dot: '社区托育试点扩容，双职工家庭选择更多' },
    { time: '08:48', dot: '青年副业与灵活就业观察：多元路径成新常态' },
    { time: '08:10', dot: '城市通勤半径扩大，双城生活人群比例上升' },
    { time: '07:26', dot: '高温天气来临，多地发布防暑与错峰用电提示' },
  ],
  '网络': [
    { time: '10:35', dot: '短视频信息流算法再引讨论，内容时长博弈加剧' },
    { time: '09:52', dot: '数字人直播规范趋严，行业进入精细化运营期' },
    { time: '09:03', dot: '社交媒体"防沉迷"功能升级，使用时长可设上限' },
    { time: '08:17', dot: '知识类长视频回归，深度内容需求明显回升' },
    { time: '07:08', dot: '网络用语年度盘点启动，网络文化持续演进' },
  ],
  '生活': [
    { time: '10:30', dot: '城市轻露营装备上新，近郊营地预订升温' },
    { time: '09:40', dot: '轻食门店加速扩张，健康餐成为午间新宠' },
    { time: '08:50', dot: '社区"第三空间"改造案例走红，自习与社交兼得' },
    { time: '08:05', dot: '精品咖啡下沉县城，一杯咖啡的消费升级' },
    { time: '07:12', dot: '夏季清凉食谱话题登顶，在家烹饪热度上涨' },
  ],
  '体育': [
    { time: '10:18', dot: '社区球类场馆预约火爆，多时段一票难求' },
    { time: '09:30', dot: '全民健身活动走进校园，青少年运动热情高涨' },
    { time: '08:44', dot: '城市马拉松报名开启，参赛名额快速报满' },
    { time: '08:00', dot: '健身房数字化转型，线上私教课需求增长' },
  ],
  '财经': [
    { time: '10:26', dot: '文旅小城目的地走红，短途游预订同比增长明显' },
    { time: '09:36', dot: '国货品牌上新提速，设计与供应链双轮驱动' },
    { time: '08:52', dot: '城市夜经济释放消费潜力，相关业态持续扩容' },
    { time: '08:08', dot: '新式茶饮出海提速，供应链本地化成为关键' },
  ],
};

export const CHANNEL_TABS = ['娱乐', '科技', '社会', '网络', '生活', '体育', '财经'];

export const TOP_RISING = [
  { rank: 1, title: '暑期档新片口碑持续分化，谁在定义"好看"', delta: '爆', heat: 986000, width: 96 },
  { rank: 2, title: '演唱会多城加场，票务与体验成关注焦点', delta: '热', heat: 812000, width: 88 },
  { rank: 3, title: '折叠屏新品发布，轻薄与耐用怎么选', delta: '升', heat: 765000, width: 82 },
  { rank: 4, title: '城市夜经济升温，青年消费场景更多元', delta: '热', heat: 703000, width: 75 },
  { rank: 5, title: '端侧大模型落地，随身助手成新热点', delta: '新', heat: 648000, width: 69 },
];

export const TOP_RISING_RIGHT = [
  { rank: 6, title: '短视频与深度内容之争，谁在重塑观看习惯', delta: '热', heat: 592000, width: 63 },
  { rank: 7, title: '文旅小城目的地走红，短途游预订增长', delta: '升', heat: 537000, width: 58 },
  { rank: 8, title: '数字主播规范趋严，虚拟形象如何更有温度', delta: '新', heat: 481000, width: 52 },
  { rank: 9, title: '社区球场预约火爆，运动成为日常社交', delta: '热', heat: 426000, width: 47 },
  { rank: 10, title: '青年副业观察：多元成长成为新常态', delta: '升', heat: 372000, width: 42 },
];

export const REPORTS = [
  {
    label: '专题深读',
    title: '一个热搜的诞生：热点从发酵到刷屏，究竟经历了什么',
    summary: '我们拆解了最近一周登上热议榜的多个话题，看内容如何在社交网络里层层放大、相互引用，最终汇入所有人的信息流。',
    time: '阅读约 8 分钟', read: '45.2万',
    image: 'https://readdy.ai/api/search-image?query=abstract%20flat%20editorial%20illustration%20of%20a%20magnifying%20glass%20over%20concentric%20rings%20of%20spreading%20signal%20and%20speech%20bubbles%2C%20warm%20cream%20background%2C%20vermillion%20red%20and%20amber%20concentric%20glow%2C%20minimal%20modern%20style%2C%20subtle%20paper%20grain%2C%20cohesive%20warm%20editorial%20illustration%20aesthetic&width=800&height=500&seq=heigua-rp-01&orientation=landscape',
  },
  {
    label: '行业观察',
    title: '票务经济冷思考：演唱会火热之下，体验与服务如何跟上',
    summary: '当热门演出一票难求，黄牛治理、退改机制与现场体验共同决定了一场演出的口碑，行业正在寻找更健康的平衡点。',
    time: '阅读约 6 分钟', read: '32.7万',
    image: 'https://readdy.ai/api/search-image?query=flat%20editorial%20illustration%20of%20a%20ticket%20booth%20window%20with%20scanning%20barcode%20and%20queue%20of%20people%2C%20warm%20cream%20background%2C%20vermillion%20red%20and%20amber%20accents%2C%20minimal%20modern%20style%2C%20subtle%20paper%20grain%2C%20cohesive%20warm%20editorial%20illustration%20aesthetic&width=800&height=500&seq=heigua-rp-02&orientation=landscape',
  },
  {
    label: '数据报告',
    title: '这一届网友的时间都花在哪了：注意力迁移全景观察',
    summary: '从短视频到长剧集，从直播带货到知识付费，我们用一组组趋势数据还原当下人们注意力的真实流向。',
    time: '阅读约 7 分钟', read: '27.9万',
    image: 'https://readdy.ai/api/search-image?query=flat%20editorial%20illustration%20of%20rising%20bar%20charts%20and%20a%20clock%20with%20flowing%20data%20ribbons%2C%20warm%20cream%20background%2C%20vermillion%20red%20and%20amber%20chart%20colors%2C%20minimal%20modern%20style%2C%20subtle%20paper%20grain%2C%20cohesive%20warm%20data%20editorial%20illustration%20aesthetic&width=800&height=500&seq=heigua-rp-03&orientation=landscape',
  },
];

export const METRICS = [
  { value: '500+', label: '每日更新快讯' },
  { value: '8', label: '内容分类栏目' },
  { value: '10万+', label: '累计收录热点' },
  { value: '5分钟', label: '平均刷新时效' },
];

export const PRINCIPLES = [
  { icon: 'ri-flashlight-line', title: '快讯首发', desc: '全网热点实时抓取，重要话题在数分钟内整理成文，让你永远抢在别人前面吃瓜。' },
  { icon: 'ri-list-check-2', title: '脉络梳理', desc: '不只搬标题，更帮你看清来龙去脉——谁先发声、如何发酵、为何刷屏，一次讲明白。' },
  { icon: 'ri-shield-check-line', title: '多方核对', desc: '对争议性话题坚持交叉核对来源，标注时间线，减少断章取义带来的误读。' },
  { icon: 'ri-compass-3-line', title: '分类导航', desc: '娱乐、科技、社会、网络、生活、体育、财经多频道聚合，想吃哪块就切哪块。' },
];

export const FAQS = [
  {
    q: '51黑瓜速递的内容更新频率是怎样的？',
    a: '51黑瓜速递属于全天候滚动更新的内容频道。热点分类与实时热榜随事件发酵即时刷新，一般在话题热度抬升的数分钟内完成整理并发布；深度特辑与行业观察则以专题形式每周不定期更新，追求信息密度而非单纯的数量。',
  },
  {
    q: '我可以按分类只看某一类内容吗？',
    a: '可以。首页顶部的热点速递板块提供了分类筛选开关，点击"娱乐、科技、社会"等标签即可只看对应分类的快讯；下方还有独立的频道快讯标签栏，支持在一类话题内连续浏览多条短讯，方便你快速锁定自己关心的领域。',
  },
  {
    q: '榜单里的热度数据是怎么来的？',
    a: '今日热榜的数据基于公开可检索的社交讨论热度、搜索量与话题参与度进行多源综合归一化计算，用于反映一段时间内公众关注的整体趋势。它更接近一种"风向参考"，帮助大家判断哪些话题正在被广泛讨论。',
  },
  {
    q: '遇到疑似不实或片面的内容怎么办？',
    a: '51黑瓜速递坚持对争议话题进行多方核对并标注信息时间线。如果你在阅读中发现任何疑似不实、断章取义或需要补充的线索，欢迎通过页面底部与我们取得联系，我们会第一时间复核并更正相关内容。',
  },
  {
    q: '这些内容可以转载或引用吗？',
    a: '欢迎在注明出处（51黑瓜速递）的前提下进行合理引用与分享。如需大段转载或用于商业用途，请先与我们沟通授权，以确保内容在传播过程中保持完整与准确。',
  },
];

export const FOOTER_LINKS = [
  { group: '栏目导航', items: ['热点速递', '频道快讯', '今日热榜', '深度特辑', '常见问题'] },
  { group: '分类频道', items: ['娱乐', '科技', '社会', '网络', '体育', '财经'] },
  { group: '关于站点', items: ['关于我们', '内容原则', '意见反馈', '联系方式'] },
];